import Creator from "../../components/directories/creator";
import React, { useState } from "react";
import Imprint from "./imprint";
import Accounts from "./Accounts";
import Fraudulent from "./Fraudulent"
import AssetDirectory from "./assetDirectory";
import Management from "../directories/Management";
import directoryServices from "./directoryServices";
import korrectLogo from '../../assets/images/korrectLogoIcon.png';

export default function DirectoriesIndex(subEntity: any) {

    let [activeMenu, setActiveMenu] = useState("Creators");
    console.log(subEntity)
    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)

        if (e != 'Chart Summary') {

            sessionStorage.setItem("modalTabOpen", JSON.stringify({ activeMenu: e }));
        }
    }

    const closeModal = (e: any) => {
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    return (<>

        {<div id="myModal" className="modal pLarge ws-12 ">

            <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                <i className="icon-close3 danger"></i>
            </a>

            <div className="allowHscroll allowVscroll full-height-vh90 ws-12 box" style={{ minHeight: "80%" }}>

                <div className="box-header-main hide"> <h2>Music Directories</h2>  </div>

                <div className="ws-12 ">
                    <div className="ws-2 pm borderReset full-height pLarge">
                        <div className="ws-12 text-center pLarge mtll mbl">
                            <img alt="Korrect" className="pull-none" src={korrectLogo} width={50} />
                        </div>

                        <ul className="main-menu pll prl ws-12">
                            <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Music Directories</a>
                            <ul >
                                {directoryServices.directoryMenu?.map((value: any) => {
                                    return (<>
                                        {(value.route !== 'accounts' && value.route !== 'fraudulent' && value.route !== 'summary') && <li key={value.title} className={activeMenu === value.title ? "active" : ""}>
                                            <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.title) }}> {value.title} </a>
                                        </li>}
                                    </>)
                                })}
                            </ul>

                            <a className="full-width text-bold text-average text-m mtll ws-12 pbl">Data Directories</a>
                            <ul>
                                {directoryServices.directoryMenu?.map((value: any) => {
                                    return (
                                        <>{(value.route === 'accounts' || value.route === 'fraudulent' || value.route === 'summary') && <li key={value.title} className={activeMenu === value.title ? "pull-left ws-12 active" : "pull-left ws-12 "}>
                                            <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.title) }}> {value.title} </a>
                                        </li>}</>
                                    )
                                })}
                            </ul>
                        </ul>
                    </div>

                    <div className="ws-10 landing">
                        {(activeMenu === 'Creators') && <Creator onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                        {(activeMenu === 'Imprints') && <Imprint onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                        {(activeMenu === 'Assets') && <AssetDirectory onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                        {(activeMenu === 'Management') && <Management onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                        {(activeMenu === 'Chart Summary') && <Management onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                        {(activeMenu === 'Accounts') && <Accounts onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                        {(activeMenu === 'Fraudulent') && <Fraudulent onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                    </div>
                </div>
            </div>

        </div>}
    </>)
}